<template>
    <div class="rankRewardInner">
        <div class="parentTabIn" style="top: 67px;">
            <ul class="nav nav-tabs" role="tablist" style="justify-content: center;">
                <li class="nav-item" v-for="tab in tabs" :key="tab.id" :style="tab.hidden ? 'display:none' : ''">
                    <button type="button" class="nav-link" :class="{ active: activeTab === tab.id }"
                        @click="changeTab(tab.id)">
                        {{ tab.label }}
                    </button>
                </li>
            </ul>
        </div>

        <div class="tab-content">
            <!-- ✅ Charm -->
            <div class="tab-pane" :class="{ active: activeTab === 'charmTab' }">
                <div class="tab-contentIn" v-if="loadedTabs.charmTab">
                    <keep-alive>
                        <weeklyRankRewardsCharm v-if="activeTab === 'charmTab'" />
                    </keep-alive>
                </div>
            </div>

            <!-- ✅ Rich -->
            <div class="tab-pane" :class="{ active: activeTab === 'richTab' }">
                <div class="tab-contentIn" v-if="loadedTabs.richTab">
                    <keep-alive>
                        <weeklyRankRewardsRich v-if="activeTab === 'richTab'" />
                    </keep-alive>
                </div>
            </div>

            <!-- ✅ Room -->
            <div class="tab-pane" :class="{ active: activeTab === 'roomTab' }">
                <div class="tab-contentIn" v-if="loadedTabs.roomTab">
                    <keep-alive>
                        <weeklyRankRewardsRoom v-if="activeTab === 'roomTab'" />
                    </keep-alive>
                </div>
            </div>

            <!-- ✅ Call -->
            <div class="tab-pane" :class="{ active: activeTab === 'callTab' }">
                <div class="tab-contentIn" v-if="loadedTabs.callTab">
                    <keep-alive>
                        <weeklyRankRewardsCall v-if="activeTab === 'callTab'" />
                    </keep-alive>
                </div>
            </div>

            <!-- ✅ Agency -->
            <div class="tab-pane" :class="{ active: activeTab === 'agencyTab' }">
                <div class="tab-contentIn" v-if="loadedTabs.agencyTab">
                    <keep-alive>
                        <weeklyRankRewardsAgency v-if="activeTab === 'agencyTab'" />
                    </keep-alive>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

export default {
    name: "AgencyRankRewardInfoComponent",

    props: {
        currentTab: {
            type: String,
            default: "agencyTab",
        },
    },

    components: {
        // ✅ Lazy load tab components (Fast)
        weeklyRankRewardsCharm: defineAsyncComponent(() =>
            import("../RankRewardInfoComponent/weeklyRankRewardsCharm.vue")
        ),
        weeklyRankRewardsRich: defineAsyncComponent(() =>
            import("../RankRewardInfoComponent/weeklyRankRewardsRich.vue")
        ),
        weeklyRankRewardsRoom: defineAsyncComponent(() =>
            import("../RankRewardInfoComponent/weeklyRankRewardsRoom.vue")
        ),
        weeklyRankRewardsCall: defineAsyncComponent(() =>
            import("../RankRewardInfoComponent/weeklyRankRewardsCall.vue")
        ),
        weeklyRankRewardsAgency: defineAsyncComponent(() =>
            import("../RankRewardInfoComponent/weeklyRankRewardsAgency.vue")
        ),
    },

    data() {
        return {
            activeTab: this.currentTab,

            // ✅ Tab list config (for template loop)
            tabs: [
                { id: "charmTab", label: "Charm", hidden: true },
                { id: "richTab", label: "Rich", hidden: true },
                { id: "roomTab", label: "Room", hidden: true },
                { id: "callTab", label: "Call", hidden: true },
                { id: "agencyTab", label: "Top Agency", hidden: false },
            ],

            // ✅ Only load active tab first
            loadedTabs: {
                charmTab: false,
                richTab: false,
                roomTab: false,
                callTab: false,
                agencyTab: true,
            },
        };
    },

    watch: {
        // ✅ When parent changes tab, update + lazy load
        currentTab(newTab) {
            this.activeTab = newTab;
            this.loadedTabs[newTab] = true;
        },
    },

    methods: {
        changeTab(tabId) {
            this.activeTab = tabId;
            this.loadedTabs[tabId] = true; // ✅ Load only when opened
        },
    },
};
</script>
